import axios from "./HttpRequestCustomerApp"

    function getcategory(){
        return axios.get('/web/menu/div');
    }
    function getcategorymenu(){
        return axios.get('/web/menu/dir');
    }

   function getMyProduct(category, page, divisions, functions, groups, text_search, tag=''){
        var _param ='';
        if(category !== undefined && category !== ''){
            _param = _param + "&categories="+category;
        }
        if(divisions !== undefined && divisions !== ''){
            _param = _param + "&divisions="+divisions;
        }
        if(functions !== undefined && functions !== ''){
            _param = _param + "&functions="+functions;
        }
        if(groups !== undefined &&  groups !== ''){
            _param = _param + "&groups="+groups;
        }
        if(text_search !== ''){
            _param = _param + "&text="+text_search;
        }
        if(tag !== undefined &&  tag !== ''){
            _param = _param + "&tags="+tag;
        }
        return axios.get('/web/product/filter/all?page='+page+'&per_page=20'+_param);
    }

    function SearchProduct(page, per_page, get_brand_info, brand_url_key, min, max, text_search){
        var _param ='';
        if(get_brand_info !== ''){
            _param = _param + "&get_brand_info="+get_brand_info;
        }
        if(brand_url_key !== ''){
            _param = _param + "&brand_url_key="+brand_url_key;
        }
        if(text_search !== ''){
            _param = _param + "&text="+text_search;
        }
        return axios.get('/web/product/filter/all?page='+page+'&min='+min+'&max='+max+'&per_page='+per_page+_param);
    }

    function getSanxu(page){
        return axios.get('/web/product/filter/all?tags=8&hotdeal=false&orderRecent=false&result_type=menu_categories&per_page=20&page='+page);
    }
    function getproductnew(page){
        return axios.get('/web/product/filter/all?tags=4&hotdeal=false&orderRecent=false&result_type=menu_categories&per_page=20&page='+page);
    }
    
   function getProductDetail(alias){
        return axios.get('/web/product'+alias);
    }

    function getProductByTab(tab,page, per_page){
        return axios.get('/web/product/interest?tab_index='+tab+'&page='+page+'&per_page='+per_page);
    }
    function getProductDetailBySku(sku){
        return axios.get('/product/'+sku, { headers: {'Authorization': "Bearer QklCT01BUlRfQVBQOkAhI19CSUJPTUFSVF9AISM=", "bbm-app-source":"bbm-service-hVkkia8MxY"}});
    }
    function getProductSearch(){
        return axios.get('/web/product/buy-often');
    }
    function getProductInterest(page, per_page, authen){
        return axios.get('/web/product/interest?tab_index=4&page='+page+'&per_page='+per_page, { headers: {'Authorization': "Bearer "+authen}});
    }
    function getCategories(){
        return axios.get('/web/menu/category/v2');
    }
    function getCategoriesV2(){
        return axios.get('/web/menu/category/v2');
    }
    function getMetaCategories(alias){
        return axios.get('/web/product/meta/category/v2/'+alias);
    }
    function getProductByCategories(page, per_page, alias){
        return axios.get('/web/product/filter/all?page='+page+'&per_page='+per_page+'&url_keys='+alias);
    }
    function getProductByCategories_v1(page, per_page, alias, get_brand_info, brand_url_key, min, max){
        var _param ='';
        if(get_brand_info !== ''){
            _param = _param + "&get_brand_info="+get_brand_info;
        }
        if(brand_url_key !== ''){
            _param = _param + "&brand_url_key="+brand_url_key;
        }
        return axios.get('/web/product/filter/all?page='+page+'&min='+min+'&max='+max+'&per_page='+per_page+'&url_keys_v2='+alias+_param);
    }
    function getProductByCategories_v2(page, per_page, alias, get_brand_info, brand_url_key, min, max){
        var _param ='';
        if(get_brand_info !== ''){
            _param = _param + "&get_brand_info="+get_brand_info;
        }
        if(brand_url_key !== ''){
            _param = _param + "&brand_url_key="+brand_url_key;
        }
        return axios.get('/web/product/filter/all?page='+page+'&min='+min+'&max='+max+'&per_page='+per_page+'&url_keys_v2='+alias+_param);
    }
    function getBrands(){
        return axios.get('/web/product/brand');
    }
    function getProductByBrand(page, per_page, alias){
        return axios.get('/web/product/brand/'+alias+'?page='+page+'&per_page='+per_page);
    }
    function getMetaBrand(alias){
        return axios.get('/web/product/meta/brand/'+alias);
    }

    function getMetaProduct(alias){
        return axios.get('/web/product/meta/'+alias);
    }

    function getBreadcrumb(alias){
        return axios.get('/web/menu/breakcrumb?url_key='+alias);
    }
    function getMenuRoot(alias){
        return axios.get('/web/menu/root/v2?url_key='+alias);
    }
    function getMenuRootV2(alias){
        return axios.get('/web/menu/root/v2?url_key='+alias);
    }
    function getMenuByUrl(alias){
        return axios.get('/web/menu/breakcrumb/'+alias);
    }

export {getMyProduct,getProductDetail,getSanxu, getproductnew, getcategory, getcategorymenu, getProductByTab, getProductDetailBySku,
    getProductSearch,getProductInterest,getCategories,getMetaCategories,getProductByCategories,getProductByBrand,getMetaBrand, getMetaProduct, 
    getBrands, getProductByCategories_v1, getBreadcrumb,getMenuRoot, getCategoriesV2,getMenuRootV2,getProductByCategories_v2,SearchProduct,getMenuByUrl}
